// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitHotelName__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitHotelName/SearchUnitHotelName.scss
 ** module id = 939
 ** module chunks = 1
 **/